/**
 * product-recommendations.js
 *
 * sections/product-recommendations.liquid always renders pr-add-to-cart.liquid
 * (a plain <product-form> + native form, the exact markup card-product.liquid
 * itself uses for a single-variant "Add to Cart") regardless of variant
 * count — so there is no "Choose options" modal path to handle here.
 *
 * This is a safety net only: normally Dawn's own <product-form> custom
 * element (product-form.js) intercepts the submit and does the AJAX add.
 * If that listener never attached for any reason — this section's content
 * only ever exists via an async fetch (Shopify never renders
 * `recommendations` synchronously on first paint), which is a timing
 * situation ordinary product-form.js usage doesn't hit — the browser would
 * otherwise do a plain form POST, which Shopify's cart endpoint redirects
 * to /cart for. This only acts if nothing already handled the submit.
 */
(function () {
  if (window.__prDirectAddBound) return;
  window.__prDirectAddBound = true;

  function getCart() {
    // Prefer the drawer — this theme's cart_type setting is "drawer", but
    // <cart-notification> always exists in the header regardless of that
    // setting, so the stock Dawn `notification || drawer` order would pick
    // the wrong one here.
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function addToCart(variantId, button) {
    if (!variantId) return;

    var cart = getCart();
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    if (button) {
      button.setAttribute('aria-disabled', true);
      button.classList.add('loading');
    }

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error(response.message || response.description || 'Could not add to cart.');
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-recommendations',
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        }
      })
      .catch(function (e) {
        console.error(e);
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
        }
      });
  }

  document.addEventListener('submit', function (event) {
    if (event.defaultPrevented) return;

    var form = event.target;
    if (!form.closest('.product-recommendations')) return;

    var variantInput = form.querySelector('[name="id"]');
    var variantId = variantInput ? variantInput.value : null;
    if (!variantId) return;

    event.preventDefault();
    addToCart(variantId, form.querySelector('[type="submit"]'));
  });
})();
